import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'; // Import useParams
import { useHistory } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';

const CompanyEdit = ({ match }) => {
    const recordId = match.params.id; // Assuming you're using React Router
    const history = useHistory();
    const [pinCodes, setPinCodes] = useState([]);

    const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const [formData, setFormData] = useState({
        Name: '',
        CompanyCode: '',
        ContactNumber1: '',
        ContactNumber2: '',
        Email: '',
        GSTNumber: '',
        AddressLine1: '',
        AddressLine2: '',
        PinCode: '',
        City: '',
        District: '',
        State: '',
        Country: '',
        BillRemarks: '',
        ReprintPassword: '',
        PaymentQRUPIId: '',
        PaymentQRUPIName: '',
    });

    const companyid = 1;
    useEffect(() => {
        fetchData('PinCodeApi', `/${companyid}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setPinCodes(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching PIN codes:', error);
            });
    }, []);

    const handlePinCodeChange = (event) => {
        const value = event;
        if (value.length === 6) {
            const selectedPinCode = pinCodes.find(pinCode => pinCode.Postcode === value);
            if (selectedPinCode) {
                setFormData(prevData => ({
                    ...prevData,
                    City: selectedPinCode.City,
                    District: selectedPinCode.District,
                    State: selectedPinCode.State,
                    Country: selectedPinCode.Country
                }));
            }
        }
    };

    useEffect(() => {
        fetchData('CompanyApi', `/CompanyDetails/${recordId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Company Details:', error);
            });
    }, []);


    const handleChange = event => {
        const { name, value } = event.target;
        console.log(name, value); // Add this line to debug
        setFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = event => {
        event.preventDefault();

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: 1,
        }));

        updateData('CompanyApi', `${recordId}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/companyIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });

    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;


    return (

        <div className="w-full max-w-sm container mt-2 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className="w-full mb-2 flex">
                    <h5 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Company - Edit</h5>                    
                    <Button
                        variant="contained"
                        style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                        onClick={handleSubmit}
                    >
                        UPDATE
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to="/companyIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px' }}
                    >
                        CANCEL
                    </Button>
                </div>
                {/* Render fetched data */}
                <div className="w-full mb-4 flex">
                    <div className="w-4/5 mr-2">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="name">
                            Company Name
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Name' value={formData.Name} onChange={handleChange} type="text" placeholder="Enter Company name"
                            required
                            maxLength={50}
                        />
                    </div>

                    <div className="w-1/5 mr-2">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="name">
                            Company Code
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Name' value={formData.CompanyCode} onChange={handleChange} type="text" placeholder="Enter Company Code" readOnly />
                    </div>

                </div>



                <div className="w-full mb-4 flex">
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="contactNumber1">
                            Contact Number 1
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='ContactNumber1' value={formData.ContactNumber1} onChange={handleChange} type="text" placeholder="Enter Contact Number 1"
                            required
                            maxLength={15}
                            pattern={phoneNumberPattern.source}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="contactNumber2">
                            Contact Number 2
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='ContactNumber2' value={formData.ContactNumber2} onChange={handleChange} type="text" placeholder="Enter Contact Number 2"
                            maxLength={15}
                            pattern={phoneNumberPattern.source}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="email">
                            Email
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Email' value={formData.Email} onChange={handleChange} type="text" placeholder="Enter Email"
                            maxLength={30}
                            pattern={emailPattern.source}
                        />
                    </div>

                    <div className="w-1/4">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="gstNumber">
                            GST Number
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='GSTNumber' value={formData.GSTNumber} onChange={handleChange} type="text" maxLength={15} placeholder="Enter GST Number" />
                    </div>

                </div>

                <div className="w-full mb-4 flex">
                    {/* <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="name">
                            Invoice Remarks
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='BillRemarks' value={formData.BillRemarks} onChange={handleChange} type="text" placeholder="Enter Invoice Remarks"
                            maxLength={200}
                        />
                    </div>

                    <div className="w-1/5 mr-2">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="name">
                            KOT Reprint Password
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='ReprintPassword' value={formData.ReprintPassword} onChange={handleChange} type="password" placeholder="Enter password"
                            maxLength={10}
                        />
                    </div> */}
                    {isSuperAdmin && (
                        <>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="name">
                                    Payment QR UPI Id
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='PaymentQRUPIId' value={formData.PaymentQRUPIId} onChange={handleChange} type="text" placeholder="Enter UPI Id" />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="name">
                                    Payment QR UPI Name
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='PaymentQRUPIName' value={formData.PaymentQRUPIName} onChange={handleChange} type="text" placeholder="Enter UPI Name" />
                            </div>
                        </>
                    )}



                </div>

                <div className="w-full mb-4 flex">
                    <div className="w-1/2 mr-2">
                        <label className="block  tracking-wide text-white text-base font-bold mb-2" htmlFor="AddressLine1">
                            Address Line 1
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='AddressLine1' value={formData.AddressLine1} onChange={handleChange} type="text" placeholder="Enter Address Line 1"
                            maxLength={200}
                            required
                        />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block  tracking-wide text-white text-base font-bold mb-2" htmlFor="AddressLine2">
                            Address Line 2
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='AddressLine2' value={formData.AddressLine2} onChange={handleChange} type="text" placeholder="Enter Address Line 2"
                            maxLength={200}
                        />
                    </div>

                </div>
                <div className="w-full mb-4 flex">
                    <div className="w-1/2 mr-2">
                        <label className="block tracking-wide text-white text-base font-bold mb-2" htmlFor="PinCode">
                            PIN Code
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.PinCode}
                            name="PinCode"
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Pin Code"
                            list="pinCodesList"
                            onBlur={(e) => handlePinCodeChange(e.target.value)} // Handle pin code change onBlur
                            required
                        />
                        <datalist id="pinCodesList">
                            {pinCodes.map((pinCode) => (
                                <option key={pinCode.Id} value={pinCode.Postcode} />
                            ))}
                        </datalist>
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block  tracking-wide text-white text-base font-bold mb-2" htmlFor="City">
                            City
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='City' value={formData.City} onChange={handleChange} type="text" placeholder="Enter City"/>
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block  tracking-wide text-white text-base font-bold mb-2" htmlFor="District">
                            District
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='District' value={formData.District} onChange={handleChange} type="text" placeholder="Enter District" />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block  tracking-wide text-white text-base font-bold mb-2" htmlFor="State">
                            State
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='State' value={formData.State} onChange={handleChange} type="text" placeholder="Enter State" />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block  tracking-wide text-white text-base font-bold mb-2" htmlFor="Country">
                            Country
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline" name='Country' value={formData.Country} onChange={handleChange} type="text" placeholder="Enter Country"  />
                    </div>


                </div>


            </form>
        </div>

    );
};

export default CompanyEdit;
